import { App } from '@capacitor/app'
import { Browser } from '@capacitor/browser'
import { FC, useEffect } from 'react'
import { mapNativeCallbackToLocalUrl, storePendingAuthCallback } from '@shared/lib/authRedirect'

export const NativeAppUrlListener: FC = () => {
	useEffect(() => {
		const listenerPromise = App.addListener('appUrlOpen', ({ url }) => {
			const targetUrl = mapNativeCallbackToLocalUrl(url)
			if (!targetUrl || window.location.href === targetUrl) return

			void Browser.close().catch(() => {
				// Browser.close is a no-op on some Android flows.
			})
			storePendingAuthCallback(targetUrl)
			window.location.replace(targetUrl)
			window.location.reload()
		})

		return () => {
			void listenerPromise.then(listener => listener.remove())
		}
	}, [])

	return null
}
